// extracted by mini-css-extract-plugin
export var markdown = "_wc-0";
export var tableWrapper = "_wc-1";